/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartLinkToCustomerResponseFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartLinkToCustomerRequest, serializeWebhusetOrderApiFeaturesCartLinkToCustomerResponse, type WebhusetOrderApiFeaturesCartLinkToCustomerRequest, type WebhusetOrderApiFeaturesCartLinkToCustomerResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/link-to-customer
 */
export interface LinkToCustomerRequestBuilder extends BaseRequestBuilder<LinkToCustomerRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartLinkToCustomerResponse>}
     */
     put(body: WebhusetOrderApiFeaturesCartLinkToCustomerRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartLinkToCustomerResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: WebhusetOrderApiFeaturesCartLinkToCustomerRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const LinkToCustomerRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/link-to-customer";
/**
 * Metadata for all the requests in the request builder.
 */
export const LinkToCustomerRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: LinkToCustomerRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartLinkToCustomerResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartLinkToCustomerRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
